import { render, staticRenderFns } from "./BlogComentaries.vue?vue&type=template&id=790084de&"
import script from "./BlogComentaries.vue?vue&type=script&lang=js&"
export * from "./BlogComentaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports